<lib-modal
  [closeLabel]="'general.close' | translate"
  [visible]="visible()"
  [title]="'modules.multiUse.title' | translate"
  [contentTemplate]="resolvedTemplate ?? undefined"
  [saveText]="'modules.multiUse.confirm' | translate"
  [cancelText]="'modules.multiUse.cancel' | translate"
  (save)="onConfirm()"
  (cancel)="onCancel()"
  (visibleChange)="visible.set($event)"
></lib-modal>

<ng-template #content>
  <div class="muc">
    <span class="muc__icon" aria-hidden="true"><mat-icon>shield</mat-icon></span>
    <p class="muc__text">
      <strong class="muc__strong">{{ moduleTitle() }}</strong>
      @if (moduleKey()) {
        ({{ moduleKey() }})
      }
      {{ 'modules.multiUse.usedAt' | translate }}
      <strong class="muc__strong">{{ 'modules.multiUse.places' | translate: { count: usageCount() } }}</strong>
      {{ 'modules.multiUse.embedded' | translate }}
      <strong class="muc__strong">{{ 'modules.multiUse.everywhere' | translate }}</strong>
      {{ 'modules.multiUse.proceed' | translate }}
    </p>
  </div>
</ng-template>
